// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1Zlon","icons":"Header_icons__2FUeU","canvas":"Header_canvas__NRzl0"};